export const offerItems = [
  {
    title: 'The Praxis & Motor Planning Clinical Pathway™',
    subtitle: '6 Premium Volumes',
    value: 'USD $97',
    text: 'The complete educational pathway, six volumes, visual reasoning frameworks, and the core clinical organization system.',
  },
  {
    title: 'The Complete Praxis Decision Toolkit™',
    subtitle: '30+ Practical Decision Tools',
    value: 'Included',
    text: 'Observation maps, task analysis checklists, reasoning matrices, missing information filters, alternative hypothesis worksheets, and functional participation templates.',
  },
  {
    title: '5 Professional Bonuses',
    subtitle: 'Free with your purchase',
    value: 'USD $147',
    text: '',
  },
];

export const offerBonusNames = [
  'The Pediatric Praxis Intake & Interview Guide™',
  'The 15-Minute Motor Planning Case Organizer™',
  'The Praxis & Motor Planning Visual Reference Guide™',
  '10 Pediatric Praxis Case Reasoning Challenges™',
  'The Functional Motor Goals & Progress Tracker™',
];

export const finalOrganizeItems = [
  { label: 'What you observe', text: 'The child’s actual performance during a motor activity.' },
  { label: 'The demands of the task', text: 'The movements, sequences, instructions, and contextual conditions involved.' },
  { label: 'What you still need to know', text: 'The information that remains missing or uncertain.' },
  { label: 'Which explanations deserve consideration', text: 'Possible interpretations that need to be explored rather than assumed.' },
  { label: 'What functional information you want to explore', text: 'The activities, participation priorities, and observable outcomes that matter in everyday life.' },
];
